/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DChartSeriesPaddingComputedOptions {
	outer?: number;
	inner?: number;
}

export interface DChartSeriesPaddingComputed {
	outer: number;
	inner: number;
}
